import creativeAgency from '../screenshots/creative-agency.PNG';
import volunteerNetwork from '../screenshots/volunteer-network.PNG';
import emaJohn from '../screenshots/ema-john.PNG';
import travelGuru from '../screenshots/travel-guru.PNG';
import courseStation from '../screenshots/course-station.PNG';
import cfTop from '../screenshots/cf-top.PNG';

const projects = [
    {
        img: creativeAgency,
        name: 'Creative Agency',
        description: 'A MERN stack web application bulit with React, Mongo, Node',
        gitLink: 'https://github.com/kaziMashry/creative-agency-client',
        liveLink: 'https://creative-agency-by-mashry.web.app/'
    },
    {
        img: volunteerNetwork,
        name: 'Volunteer Network',
        description: 'A MERN stack web application bulit with React, Mongo, Node',
        gitLink: 'https://github.com/kaziMashry/volunteer-network-client',
        liveLink: 'https://volunteer-network-by-mashry.web.app/'
    },
    {
        img: emaJohn,
        name: 'Ema John',
        description: 'A MERN stack web application bulit with React, Mongo, Node',
        gitLink: 'https://github.com/kaziMashry/e-commerce-client',
        liveLink: 'https://e-commerce-by-mashry.web.app/'
    },
    {
        img: travelGuru,
        name: 'Travel Guru',
        description: 'A MERN stack web application bulit with React, Mongo, Node, and google map API',
        gitLink: 'https://github.com/kaziMashry/travel-guru-simple',
        liveLink: 'https://travel-guru-online.web.app/'
    },
    {
        img: courseStation,
        name: 'Course Station',
        description: 'A front-end web page bulit with React js and Material UI',
        gitLink: 'https://github.com/kaziMashry/course-station',
        liveLink: 'https://course-station.netlify.app/'
    },
    {
        img: cfTop,
        name: 'CodeForces Top 15',
        description: 'A front-end web application bulit with React js',
        gitLink: 'https://github.com/kaziMashry/codeforces-top-15',
        liveLink: 'https://codeforces-top-15-contestants.netlify.app/'
    }
];

export default projects;